module.exports = __webpack_public_path__ + "img/en-au.48d6b6b2.svg";